import React, { Fragment } from 'react';
import BasicInput from './BasicInput';
import BasicCheckboxGroup from './BasicCheckboxGroup';
import BasicAddableInput from './BasicAddableInput';

const DynamicInput = props => {
  const { type, id, addable } = props;

  if (addable) {
    return <BasicAddableInput {...props} />;
  }

  switch (type) {
    case 'text':
      return <BasicInput {...props} />;
    case 'email':
      return <BasicInput {...props} />;
    case 'url':
      return <BasicInput {...props} />;
    case 'checkboxGroup':
      return <BasicCheckboxGroup {...props} />;
    default:
      // eslint-disable-next-line no-console
      console.error(`Input ${id} was not rendered. The '${type}' input is not yet supported.`);
      return <Fragment />;
  }
};

export default DynamicInput;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/dynamic_forms/DynamicInput.jsx